/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoginCheckResult { 
    use_entra_id?: boolean;
    entra_id_domain?: string;
    trusted_required?: boolean;
}

